import React from "react";
import { Link } from "react-router-dom";
import { Sun, Mail, MapPin, Phone, Facebook, Twitter, Instagram, Linkedin, Youtube } from "lucide-react";
import { COMPANY, SERVICES } from "../lib/siteData";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-6" data-testid="site-footer">
      <div className="container-narrow grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
        <Link to="/" className="flex items-center gap-2 mb-4">
          <img src="/logo-transparent.png" alt="CNGTPL Solar" className="h-20 w-auto" />
        </Link>
        <p className="text-sm leading-relaxed text-slate-400 mb-4">
          India's trusted solar EPC brand. Clean Energy • Powering Tomorrow. Residential, commercial & industrial solar solutions backed by MNRE-approved products and a 25-year warranty.
        </p>
          <div className="flex gap-2">
            {[Facebook, Twitter, Instagram, Linkedin, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-blue-600 flex items-center justify-center transition">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4">Products & Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/products/${s.slug}`} className="text-slate-400 hover:text-blue-400 transition">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-slate-400 hover:text-blue-400">About Us</Link></li>
            <li><Link to="/business-franchise" className="text-slate-400 hover:text-blue-400">Business Franchise</Link></li>
            <li><Link to="/ev-charging" className="text-slate-400 hover:text-blue-400">EV Charging</Link></li>
            <li><Link to="/projects" className="text-slate-400 hover:text-blue-400">Projects</Link></li>
            <li><Link to="/blog" className="text-slate-400 hover:text-blue-400">Blog</Link></li>
            <li><Link to="/calculator" className="text-slate-400 hover:text-blue-400">Solar Calculator</Link></li>
            <li><Link to="/contact" className="text-slate-400 hover:text-blue-400">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
              <span className="text-slate-400">{COMPANY.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
              <a href={`tel:${COMPANY.phone}`} className="text-slate-400 hover:text-blue-400">{COMPANY.phone}</a>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
              <a href={`mailto:${COMPANY.email}`} className="text-slate-400 hover:text-blue-400">{COMPANY.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-narrow mt-12 pt-6 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
        <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
        <div className="flex gap-6">
          <a href="#" className="hover:text-blue-400">Privacy Policy</a>
          <a href="#" className="hover:text-blue-400">Terms</a>
          <a href="#" className="hover:text-blue-400">Sitemap</a>
        </div>
      </div>
    </footer>
  );
}
